import script from "./DisbursementConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./DisbursementConfirmModal.vue?vue&type=style&index=0&id=4d4e0f78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4e0f78"]])

export default __exports__